import ModalLiquidate from './ModalLiquidate'

export default ModalLiquidate
